module.exports = __webpack_public_path__ + "static/media/r7.e545e8ed.png";